import { useMemo } from 'react'

import { useUserInfo } from '#/store/ducks/auth'
import { useAnimal, useProduction, useThi } from '#/store/ducks/context'
import { useFarmPlan, usePregnancyActive } from '#/store/ducks/farm'
import { usePermissions } from '#/store/ducks/permissions'
import useAppContext from '#/store/hooks/useAppContext'

export function usePageConditions() {
  const permissions = usePermissions()
  const { secondPregnancy, thirdPregnancy } = usePregnancyActive()
  const { slug: farm_plan } = useFarmPlan()
  const { farm_count, has_company } = useUserInfo() as any
  const { is_female } = useAnimal()
  const { type: productionType } = useProduction()
  const { id: point } = useThi()
  const context = useAppContext()

  return useMemo(
    () =>
      ({
        context,
        farm_count,
        farm_plan,
        has_company,
        is_female,
        permissions,
        point,
        productionType,
        secondPregnancy,
        thirdPregnancy,
      }) as const,
    [
      farm_count,
      has_company,
      permissions,
      secondPregnancy,
      thirdPregnancy,
      is_female,
      productionType,
      point,
      farm_plan,
      context,
    ],
  )
}
